import React, {FC, ReactNode} from 'react';
import classNames from 'classnames';
import {useCtxConfig} from 'pages/dashboard/components/FirstLook/context';
import {Background} from 'pages/dashboard/components/FirstLook/Elements/Background';
import {Footer} from 'pages/dashboard/components/FirstLook/Elements/Footer';
import {Header} from 'pages/dashboard/components/FirstLook/Elements/Header';

import * as styles from './styles.module.scss';

interface ScreenProps {
	className?: string
	children: ReactNode
}

export const Screen: FC<ScreenProps> = ({className, children}) => {
	const {swipes} = useCtxConfig();
	return (
		<div {...swipes} className={classNames(styles.wrapper, className)}>
			<Background className={styles.background} />
			<div className={styles.foreground}>
				<Header className={styles.header} />
				<div className={styles.content}>
					{children}
				</div>
				<Footer className={styles.footer} />
			</div>
		</div>
	);
};

export const Positioner: FC = () => {
	return (
		<div className={classNames(
			styles.wrapper,
			styles.positioner,
		)} />
	);
};
